import { render } from "./CustomerItem.vue?vue&type=template&id=9bc02fc8"
import script from "./CustomerItem.vue?vue&type=script&lang=js"
export * from "./CustomerItem.vue?vue&type=script&lang=js"

import "./CustomerItem.vue?vue&type=style&index=0&id=9bc02fc8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__